import axios from 'axios';
import { objectToQuery } from '@mx/util/object-to-query';
import { toast } from '@mx/vix';
import { bridge } from './bridge';
import { env } from './env';
import modal from '@/service/modal';

export enum ErrorLevel {
  TOAST = 1,
  MODAL_EXIT,
  MODAL,
  EXIT,
  INLINE
}

interface AjaxSettings {
  showToast?: boolean; // 是否展示toast
  needCommonErrorHandler?: boolean; // 是否使用通用错误处理
}

class CustomError extends Error {
  constructor(
    message: string,
    public level: ErrorLevel,
    public code: number,
    public type: string
  ) {
    super(message);
  }
}

export function post(
  url: string,
  data: any,
  settings: AjaxSettings = { showToast: true, needCommonErrorHandler: true }
) {
  if (settings.showToast) {
    toast.show();
  }
  const params = env.isHarmony ? {} : {
    member_id: env.memberId,
  };
  return axios
    .post(url, data, {
      transformRequest: (rawData) => {
        rawData = { ...env.commonParams, ...rawData };
        return objectToQuery(rawData);
      },
      params,
    })
    .then((res) => {
      if (settings.showToast) {
        toast.hide();
      }
      // 响应体
      const body = res.data;
      if ('error' in body) {
        const error = body.error;
        throw new CustomError(
          error.message,
          error.level,
          error.code,
          error.type
        );
      }
      // 响应体中数据
      return body.data;
    })
    .catch((error) => {
      if (settings.showToast) {
        toast.hide();
      }
      if (settings.needCommonErrorHandler) {
        errorHandler(error);
      }
      throw error;
    });
}

function errorHandler(error: CustomError): void {
  // 通用错误码处理
  if (error.code === 118013) {
    return retrievePassword(error.message);
  }

  switch (error.level) {
    case ErrorLevel.TOAST:
      toast.show('text', error.message);
      break;
    case ErrorLevel.MODAL_EXIT:
    case ErrorLevel.EXIT:
      modal.show({
        title: '提示',
        content: error.message,
        button: {
          text: '知道了',
          onClick: () => {
            modal.hide();
            bridge.closePage();
          }
        }
      });
      break;
    case ErrorLevel.MODAL:
      modal.show({
        title: '提示',
        content: error.message,
        button: {
          text: '知道了',
          onClick: () => {
            modal.hide();
          }
        }
      });
      break;
  }
}

/**
 * 找回密码提示
 * @param message 提示信息
 */
function retrievePassword(message: string) {
  modal.show({
    title: '提示',
    content: message,
    button: [
      {
        text: '取消',
        onClick: modal.hide
      },
      {
        text: '找回密码',
        onClick: () => {
          bridge.retrievePassword();
          modal.hide();
        }
      }
    ]
  });
}
